//src\components\About.js
import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import '../App.css';

// المكونات
import StatsCounter from './StatsCounter';
import MissionVision from './MissionVision';
import WhyChooseUs from './WhyChooseUs';
import ProjectMapWork from './ProjectMapWork';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.2 }
  }
};

const itemVariants = {
  hidden: { y: 30, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 0.5 }
  }
};

function About() {
  const aboutData = {
    intro: {
      title: 'نبذة عن UN-BORDERS',
      paragraphs: [
        'تأسست UN-BORDERS برؤية تهدف إلى إعادة تعريف فن العمارة والاستشارات الهندسية. نحن فريق من المهندسين والمصممين المبدعين، نعمل بشغف على تحويل الأفكار إلى واقع ملموس، مع التركيز على الابتكار والاستدامة.'
      ],
      backgroundImage: '/images/تصميم_داخلي_لفيلا_1.jpg'
    },
    stats: [
      { id: 1, label: 'مشروع مكتمل', value: 1150, suffix: '+' },
      { id: 2, label: 'سنة خبرة', value: 15, suffix: '+' }
    ],
    mission: 'مهمتنا هي ترجمة رؤى عملائنا إلى تصميمات فريدة تتجاوز التوقعات، مع الالتزام بأعلى معايير الجودة والاستدامة في الاستشارات الهندسية.',
    vision: 'رؤيتنا أن نكون الرواد في تقديم حلول التصميم المعماري والهندسي المبتكرة في المنطقة، وأن نكون الخيار الأول للعملاء الباحثين عن التميز والإبداع.',
    whyUs: [
      { id: 1, title: 'تصميمات مبتكرة', description: 'نقدم حلولاً إبداعية خارج الصندوق.' },
      { id: 2, title: 'خبرة استشارية', description: 'فريقنا يقدم استشارات هندسية دقيقة.' },
      { id: 3, title: 'الالتزام بالاستدامة', description: 'نطبق معايير البناء الأخضر في تصميماتنا.' }
    ],
    partners: [
      // { id: 1, name: 'Saudi Build', logo: '/images/partners/arkon.jpg' },
      { id: 2, name: 'Alfanar', logo: '/images/partners/روائع المدن.jpg' },
      { id: 3, name: 'Aramco', logo: '/images/partners/تطابق.jpg' }
      // { id: 4, name: 'NEOM', logo: '/images/partners/كينج.jpg' }
    ]
  };

  const { scrollY } = useScroll();
  const yPos = useTransform(scrollY, [0, 500], [0, 100]);

  return (
    <motion.div className="about-page" variants={containerVariants} initial="hidden" animate="visible">
      {/* --- المقدمة --- */}
      <motion.section
        variants={itemVariants}
        className="about-intro"
        style={{
          backgroundImage: `url(${aboutData.intro.backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          y: yPos,
        }}
      >
        <div className="intro-overlay"></div>
        <div className="intro-content">
          <h1>{aboutData.intro.title}</h1>
          {aboutData.intro.paragraphs.map((p, i) => (
            <p key={i} className="about-text">{p}</p>
          ))}
        </div>
      </motion.section>

      {/* باقي الصفحة */}
      <div className="about-content-wrapper">
        <motion.section variants={itemVariants}>
          <StatsCounter stats={aboutData.stats} />
        </motion.section>

        <motion.section variants={itemVariants}>
          <MissionVision mission={aboutData.mission} vision={aboutData.vision} />
        </motion.section>

        <motion.section variants={itemVariants}>
          <WhyChooseUs items={aboutData.whyUs} />
        </motion.section>

        {/* --- قسم شركاؤنا --- */}
        <motion.section className="partners-section" variants={itemVariants}>
          <h2 className="section-title">شركاؤنا</h2>
          <div className="partners-logos">
            {aboutData.partners.map((partner) => (
              <motion.div key={partner.id} className="partner-card" whileHover={{ scale: 1.1 }}>
                <img src={partner.logo} alt={partner.name} className="partner-logo" />
              </motion.div>
            ))}
          </div>
        </motion.section>

        {/* --- قسم المشاريع --- */}
        <motion.section variants={itemVariants}>
          <h2 className="section-title">أماكن مشاريعنا</h2>
          <ProjectMapWork />
        </motion.section>
      </div>
    </motion.div>
  );
}

export default About;
